<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Список офферов ({{ offers.length }})</h2>
            </div>
            <div class="column">
                <v-select
                    v-model="is_shown"
                    :items="show"
                    item-text="name"
                    item-value="value"
                    label="Виден ли оффер?"
                    @click:clear="onClear"
                    @input="filterOffers()"
                    outlined
                    dense
                    clearable
                ></v-select>
            </div>
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="plus"
                    @click="create()"
                    >Добавить</b-button
                >
            </div>
        </div>
        <div style="margin-top: 60px;">
            <div class="columns scrollable" ref="scrollable">
                <draggable
                    class="column"
                    v-model="offers"
                    draggable=".draggable-item"
                    v-bind="dragOptions"
                >
                    <transition-group type="transition">
                        <div class="draggable-item" v-for="offer in offers" :key="offer.id">
                            <div class="level">
                                <div class="level-item has-text-centered">
                                    <div>
                                        <i
                                            class="icon is-medium mdi mdi-dark mdi-menu"
                                            style="font-size: 24px;"
                                        ></i>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="title is-4">{{ offer.name }}</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div class="image" style="width: 150px;">
                                        <img v-bind:src="offer.img_path" />
                                        <p
                                            class="heading"
                                            style="font-size: 14px; margin-top: 5px;"
                                        >
                                            Рейтинг: {{ offer.rate }}/5
                                        </p>
                                    </div>
                                </div>
                                <div class="level-item">
                                    <div>
                                        <p class="heading has-text-centered">Сумма займа</p>
                                        <p class="title is-4">до {{ offer.sum }} руб.</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading">Срок займа</p>
                                        <p class="title is-4">до {{ offer.days }} дней</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading">Процентная ставка</p>
                                        <p class="title is-4">от {{ offer.bet }}% в день</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <b-button icon-right="chevron-right" @click="edit(offer)"
                                            >Редактировать</b-button
                                        >
                                        <b-tooltip label="Скрыть">
                                            <b-button
                                                v-if="offer.show"
                                                icon-right="eye-outline"
                                                @click="switchShow(offer)"
                                            ></b-button>
                                            <b-button
                                                v-else
                                                icon-right="eye-off-outline"
                                                @click="switchShow(offer)"
                                            ></b-button>
                                        </b-tooltip>
                                        <!-- <b-tooltip label="Удалить">
                                            <b-button
                                                type="is-danger"
                                                icon-right="delete"
                                                @click="remove(offer)"
                                            >
                                            </b-button>
                    </b-tooltip>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <div class="columns" style="margin-top: 20px;">
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="check"
                    @click="save()"
                    >Сохранить</b-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "AdminOfferList",
    components: {
        draggable,
    },
    data() {
        return {
            show: [
                { name: "Да", value: true },
                { name: "Нет", value: false },
            ],
            is_shown: true,
        };
    },
    created() {
        this.$store.dispatch("GET_OFFERS", this.is_shown);
    },
    computed: {
        offers: {
            get() {
                return this.$store.getters.OFFERS;
            },
            set(value) {
                this.$store.commit("SET_OFFERS", value);
            },
        },
        dragOptions() {
            return {
                animation: 200,
                scroll: true,
                scrollSensitivity: 100,
                scrollSpeed: 10,
            };
        },
        filters: {
            get() {
                return this.$store.getters.GET_OFFER_FILTERS;
            },
        },
    },
    methods: {
        save() {
            this.$store
                .dispatch("CHANGE_OFFERS")
                .then(() => {
                    this.$toaster.success("Настройки сохранены");
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        edit(offer) {
            const route = this.$router.resolve({
                path: `/admin/offers/update/${offer.id}`,
            });
            window.open(route.href, "_blank");
        },
        create() {
            const route = this.$router.resolve({ path: "/admin/offers/create/" });
            window.open(route.href, "_blank");
        },
        remove(offer) {
            this.$store
                .dispatch("DELETE_OFFER", offer.id)
                .then(() => {
                    this.$toaster.success("Оффер удален");
                    this.$store.dispatch("GET_OFFERS");
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        switchShow(offer) {
            this.$store.dispatch("UPDATE_OFFER_SHOW", offer);
        },
        onClear() {
            this.$store.dispatch("GET_OFFERS", this.is_shown);
        },
        filterOffers() {
            this.$store.dispatch("GET_OFFERS", this.is_shown);
        },
    },
};
</script>

<style>
.draggable-item {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 15px;
    background-color: #fff;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.scrollable {
}
</style>
